import { useEffect } from 'react'
import { getConsumer } from '../services/actionCable'

// Subscribes to the InterviewChannel for a given PromptActivation and
// forwards every broadcast to onMessage. Tear-down on unmount and on
// activation change.
//
// Phase 2/2b: the channel streams per-activation (was per-interview_session
// pre-merge). Backend reads `params[:prompt_activation_id]` in
// InterviewChannel#subscribed, so the subscription payload must use that
// key. Used by the Respond page for live transcribed/analyzed status.
//
// NOTE: pass a referentially-stable onMessage (useCallback) — it's an effect
// dependency, so a new function per render would resubscribe every render.
export function useInterviewChannel(activationId, onMessage) {
  useEffect(() => {
    if (!activationId) return undefined
    const consumer = getConsumer()
    if (!consumer) return undefined

    const subscription = consumer.subscriptions.create(
      { channel: 'InterviewChannel', prompt_activation_id: activationId },
      {
        received(data) {
          onMessage?.(data)
        },
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [activationId, onMessage])
}
